var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('a-table',{attrs:{"rowKey":"id","bordered":"","columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }